var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.67773H3.5C2.11929 1.67773 1 2.79702 1 4.17773V9.17773C1 10.5584 2.11929 11.6777 3.5 11.6777H8.5C9.88071 11.6777 11 10.5584 11 9.17773V4.17773C11 2.79702 9.88071 1.67773 8.5 1.67773Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99985 6.36264C8.06156 6.77876 7.99048 7.20375 7.79673 7.57715C7.60298 7.95055 7.29643 8.25335 6.92067 8.44248C6.54491 8.63161 6.11908 8.69744 5.70375 8.63061C5.28842 8.56377 4.90473 8.36768 4.60727 8.07022C4.30981 7.77276 4.11372 7.38908 4.04689 6.97375C3.98005 6.55842 4.04589 6.13259 4.23502 5.75683C4.42415 5.38107 4.72695 5.07451 5.10035 4.88076C5.47375 4.68701 5.89873 4.61594 6.31485 4.67764C6.73932 4.74058 7.13228 4.93837 7.4357 5.24179C7.73912 5.54522 7.93691 5.93818 7.99985 6.36264Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.92773H8.755",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_3160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.677734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon);
export default __webpack_public_path__ + "static/media/social-icon.31cd5600d20f9e9c3100782ce86729fe.svg";
export { ForwardRef as ReactComponent };